import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ChatIcon, ChatIconOutline, DotDotDotVerticalIcon, MutedSpeakerIcon, ShareIcon, UnmutedSpeakerIcon, } from '@streamr/tv-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { useShare } from '../../hooks/useShare';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { formBroadcastUrl } from '../../utils/url';
import { Anchor } from '../Anchor';
import { Button as LegacyButton } from '../Button';
import { RequestToSpeakButton } from '../broadcaster/RequestToSpeakButton';
import { openViewerOptions } from '../popups/ViewerOptionsPopup';
export function ViewerViewFooter({ audioMuted = false, onSidebarClick, showSidebar, onAudioToggle, }) {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const navigate = useNavigate();
    const { canShare, openSystemShareDialog } = useShare();
    const optionsButtonAnchorRef = useRef(null);
    const broadcastUrl = formBroadcastUrl(activeBroadcast);
    return (_jsxs(ViewerViewFooterRoot, { children: [_jsxs(LeftSide, { children: [_jsx(LegacyButton, { type: "button", shape: "pill", padding: "none", kind: audioMuted ? undefined : 'secondary', variant: audioMuted ? undefined : 'dark', icon: audioMuted ? (_jsx(MutedSpeakerIcon, {})) : (_jsx(UnmutedSpeakerIcon, {})), onClick: () => {
                            onAudioToggle?.();
                        } }), canShare && (_jsx(LegacyButton, { type: "button", kind: "secondary", shape: "pill", padding: "none", variant: "dark", icon: _jsx(ShareIcon, {}), onClick: () => {
                            openSystemShareDialog(broadcastUrl);
                        } })), _jsx(RequestToSpeakButton, {}), _jsx(LegacyButton, { type: "button", kind: "destructive", shape: "pill", onClick: () => {
                            void navigate('/');
                        }, children: "Leave" })] }), _jsxs(RightSide, { children: [_jsx(ChatButton, { title: "Chat", onClick: () => onSidebarClick(), children: showSidebar ? _jsx(ChatIcon, {}) : _jsx(ChatIconOutline, {}) }), _jsx(Anchor, { ref: optionsButtonAnchorRef, children: _jsx(BaseButton, { title: "Settings", onClick: () => {
                                openViewerOptions({
                                    anchorRef: optionsButtonAnchorRef,
                                    activeBroadcast,
                                    variant: 'desktop',
                                });
                            }, children: _jsx(DotDotDotVerticalIcon, {}) }) })] })] }));
}
const ViewerViewFooterRoot = styled.div `
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    padding: 1.5rem;
`;
const LeftSide = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap-reverse;
    max-width: 60%;
`;
const RightSide = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
`;
const BaseButton = styled(Button) `
    --Button_Width: 3rem;
    --Button_Height: 3rem;
    color: var(--tv-ui-color-3);
`;
const ChatButton = styled(BaseButton) `
    display: none;
    @media (min-width: 60rem) {
        display: flex;
    }
`;
